import React, { useState } from "react";
import EquipmentForm from "./equipmentform";
import { dash } from "./displayValue";
import "../component/css/listing-table.css";

// Compatible-parts row on the part detail page. Renders one <tr>; the parent
// owns the table. No "more details" here - only the inquire action.
function PartsDetailsInventory(props) {
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  const handleInquireButtonClick = () => setShowInquiryModal(true);
  const handleCloseInquiryModal = () => setShowInquiryModal(false);

  const row = props.data || {};

  return (
    <tr>
      <td className="cell-id">{dash(props.jad_id)}</td>
      <td>{dash(row["Product_Description"])}</td>
      <td>{dash(row["Manufacturer_Id"])}</td>
      <td>{dash(props.Parts_number)}</td>
      <td>{dash(props.Revision)}</td>
      <td className="cell-actions">
        <div className="listing-actions">
          <button className="inquire-btn" onClick={handleInquireButtonClick}>
            INQUIRE
          </button>
        </div>
        <EquipmentForm
          showInquiryModal={showInquiryModal}
          handleCloseInquiryModal={handleCloseInquiryModal}
          values={props}
          producttype="inventory"
        />
      </td>
    </tr>
  );
}

export default PartsDetailsInventory;
